import { useState, useEffect } from 'react';
// import { cn } from '~/utils/';
// import { SetCookie, GetCookie } from '~/utils/cookie';
import { usePopup } from '~/helpers/store';
import { getPrefixLocation } from "../../utils/main";
// import Unlimited from "~/components/svg/Unlimited";
// import Check from "~/components/svg/Check";
// import Close from "~/components/svg/Close";
// import PricingCard from "~/components/PricingCard";
// import Shine from "~/components/svg/Shine";
import LazyDisplay from "../Modal/LazyDisplay";
import { MdOutlineCancel } from "react-icons/md";
import './style.css';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export default function PricingModal() {
    const pState = usePopup((state) => state);
    const [slug, setSlug] = useState("register-auth");

    useEffect(() => {
        const checkEmail = () => {
          if (cookies.get("user_email")) {
            setSlug("pricing");
          } else {
            setSlug("register-auth");
          }
        };
    
        checkEmail(); 
        const interval = setInterval(checkEmail, 1000); 
    
        return () => clearInterval(interval); 
      }, [pState.showPricingPopup]);

      if (!pState.showPricingPopup) {
        return null;
      }

    // const [ features ] = useState([
    //     "PDFs Upload",
    //     "Questions",
    //     "PDFs Pages",
    //     "Folders",
    //     "PDF File Size"
    // ]);
    const startURL = process.env.REACT_APP_START_URL || 'https://start.ai-pro.org';
    const paymentURL = startURL + '/pay';

    // const redirectUpgrade = () => {
    //     window.location.href = paymentURL;
    // }

    const modalStyles = slug === 'register-auth'
    ? 'h-[85%] max-h-720:!h-[94%] xl:h-[70%] min-w-2560:h-[50%] min-w-[26%] md:min-w-[30%] md:w-full md:max-w-[62%] lg:max-w-[50%] xl:max-w-[36%] min-w-2560:max-w-[28%] min-w-2560:min-w-[26%] transition-all delay-150 duration-300 ease-in-out'
    : 'transition-all delay-150 duration-300 ease-in-out md:min-w-[710px] md:w-[68%] md:max-w-[68%] max-w-768-1280:h-[90%] h-[85%]';

    // Create the URL with the appropriate parameters
    const getIframeUrl = () => {
      const baseUrl = `https://${getPrefixLocation()}start.ai-pro.org/${slug}`;
      if (slug === "register-auth") {
        // Use a direct string with the correct encoding
        return baseUrl + "?reg_google=on&reg_apple=on";
      }
      return baseUrl;
    };

    return (
        <>
        <div 
      className="fixed inset-0 flex items-center justify-center z-[100] bg-black/50" 
      onClick={()=>{
        pState.setShowPricingPopup(false);
    }}
    >
      <div 
        className={`w-[90%] max-h-[1020px] min-w-2000:!max-w-[1400px] rounded-3xl my-auto relative ${modalStyles}`}
      >
        <iframe
          src={getIframeUrl()}
          title="Register Authentication"
          frameBorder="0"
          className="w-full h-full rounded-3xl"
        />
        <LazyDisplay delay={360}>
          <MdOutlineCancel
            className="absolute top-4 right-4 h-5 w-5 text-gray-600 cursor-pointer"
            onClick={()=>{
                pState.setShowPricingPopup(false);
            }}
          />
        </LazyDisplay>
      </div>
    </div>
        </>
    );
}